import React, { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import Header from '../../components/Header'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import queryString from 'query-string'
import { Switch, withRouter } from 'react-router-dom'
import { FaroRoute } from '@grafana/faro-react'
import { ThemeProvider } from 'styled-components'
import RiskDataCollectionPage from '../RiskDataCollectionPage'
import { PageNotFound } from '../../components/PageNotFound'
import PolicyConfirmationPage from '../PolicyConfirmationPage'
import InvalidRegPage from '../InvalidRegPage'
import ErrorPage from '../../components/ErrorPage'
import AppWrapper from './AppWrapper'
import HoldingPage from '../../components/HoldingPage'
import themeService from '../../services/themeService'
import { SWINTON_REF } from '../../services/affiliateConstants'
import { appendSwintonGtmTags } from '../../services/affiliateServices'
import TrustPilot from '../../components/TrustPilot'
import { WHITE_LABEL } from '../../services/affiliateConstants'
import {
  createClientSession,
  updateClientSessionQuote,
  setClientSessionLastActivity,
} from './actions'
import useSession from '../../hooks/useSession/useSession'
import { usePrevious } from 'hooks'
import { handleAllowedScripts } from '../../utils/handle-allowed-scripts'
import PolicyInProgress from 'pages/Policy/InProgress'
import { AnalyticsWrapper } from 'components/Analytics/AnalyticsWrapper'

const App = (props) => {
  const prevPath = usePrevious(window.location.pathname)
  const { manageSession } = useSession()

  useEffect(() => {
    const parsedQueryString = queryString.parse(window.location.search)
    if (
      parsedQueryString.ref &&
      parsedQueryString.ref.toLowerCase() === SWINTON_REF.toLowerCase()
    ) {
      appendSwintonGtmTags()
    }
    // handle allowed scripts
    const removeCookieConsentListener = handleAllowedScripts()
    if (window.isHoldingPageOn) {
      props.history.push(`/holding-page`)
    }
    return removeCookieConsentListener
  }, [])

  useEffect(() => {
    if (window.location.pathname !== prevPath) {
      manageSession(window.location)
      window.scrollTo(0, 0)
    }
  }, [window.location.pathname])

  return (
    <ThemeProvider theme={themeService.getTheme(props.affiliate)}>
      <AnalyticsWrapper>
        <AppWrapper>
          <>
            {props.affiliate.AffiliateType !== WHITE_LABEL &&
              !props.isLoading && <TrustPilot />}
            <Header
              affiliate={props.affiliate}
              isLoading={props.isLoading}
              campaignRef={props.campaignRef}
            />
            <Switch>
              <FaroRoute path='/error' component={ErrorPage} />
              <FaroRoute path='/holding-page' component={HoldingPage} />
              <FaroRoute
                path='/policy/confirmation'
                component={PolicyConfirmationPage}
              />
              <FaroRoute path='/policy/in-progress' component={PolicyInProgress} />
              <FaroRoute path='/vehicle/invalid-reg' component={InvalidRegPage} />
              <FaroRoute path='/' component={RiskDataCollectionPage} />
              <FaroRoute component={PageNotFound} />
              {/* Future roots into app, Admin, MyAccount...... */}
            </Switch>
            {/* <IntercomComponent /> */}
          </>
        </AppWrapper>
      </AnalyticsWrapper>
    </ThemeProvider>
  )
}

function mapStateToProps(state, ownProps) {
  return {
    affiliate: state.affiliate,
    location: ownProps.location,
    step: state.step,
    router: state.router,
    showLiveChat: state.showLiveChat,
    isLoading: state.isLoading,
    campaignRef:
      (state.price && state.price.campaign && state.price.campaign.Ref) || null,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        createClientSession,
        updateClientSessionQuote,
        setClientSessionLastActivity,
      },
      dispatch,
    ),
  }
}

App.propTypes = {
  theme: PropTypes.shape({
    logo: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  }),
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
